/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';

import { TableHeaderProps } from '../interface';
import { Sortable } from '../styles';
import TableMultSelectButton from './TableMultSelectButton';

function TableHeader<Entity>({
  columns,
  hasMenu,
  hasSelectedEntities,
  hasBorderColor,
  sorting,
  multipleActionOption,
  disableMultSelectButton,
  loadingMultSelectButton,
}: TableHeaderProps<Entity>) {
  const toggleSort = (id: keyof Entity) => {
    if (!sorting) return 'asc';

    if (id === sorting?.sortBy) {
      return sorting.sortBy === 'asc' ? 'desc' : 'asc';
    }
    return sorting?.sortOrder;
  };

  const handleToggleSort = (id: keyof Entity) => {
    const newSortOrder = toggleSort(id);
    if (sorting) {
      sorting.onChange(id, newSortOrder);
    }
  };

  return (
    <thead>
      <tr>
        {hasSelectedEntities && <th />}
        {hasBorderColor && <th />}
        {columns.map((column) =>
          sorting && column.id && column.condition !== false ? (
            <th style={column.style}>
              <Sortable
                type="button"
                onClick={() => column.id && handleToggleSort(column.id)}
              >
                {column.header}
                {sorting.sortOrder === 'desc' &&
                sorting.sortBy === column.id ? (
                  <MdArrowDropDown size={20} />
                ) : (
                  <MdArrowDropUp size={20} />
                )}
              </Sortable>
            </th>
          ) : (
            column.condition !== false && (
              <th style={column.style}>{column.header}</th>
            )
          ),
        )}
        {hasMenu && (
          <th
            style={{
              width: '1%',
              paddingTop: '10px',
            }}
          >
            {multipleActionOption && (
              <TableMultSelectButton
                multipleActionOption={multipleActionOption}
                disableMultSelectButton={disableMultSelectButton}
                loadingMultSelectButton={loadingMultSelectButton}
              />
            )}
          </th>
        )}
      </tr>
    </thead>
  );
}

export default TableHeader;
